import { useQuery, useQueryClient } from '@tanstack/react-query';
import { localStateKeys } from '../utils/reportviewutils';
import { getMeasuremetResults } from '../services/report/function';
import { measurementKeys } from '../services/report/key';
import '../styles/main.css';

function Loader() {
  const queryClient = useQueryClient();
  const numBlocks = queryClient.getQueryData<number>(localStateKeys.maxBlocks);
  
  const { status, data, error } = useQuery({
    queryKey: measurementKeys.all,
    queryFn: getMeasuremetResults,
    staleTime: Infinity,
    meta: { numBlocks : numBlocks, numParams : 10, numResults : 10 },
  });

  // if (isPending) 
  if (status === 'pending') {
    return <h2 className="animate">Loading</h2>
  }

  // if (isError) 
  if (status === 'error') {
    return <span key='iserror'>Error: {error.message}</span>
  }

  return <>
    { 
      (() => {
        data;
        return null;
      })() && undefined
    }
  </>
}

export default Loader;